export const TIPS_TO_POINTS = {
    0: {
        coins: 100,
        tickets: 5,
    },
    1: {
        coins: 70,
        tickets: 3,
    },
    2: {
        coins: 50,
        tickets: 1,
    },
    3: {
        coins: 20,
        tickets: 0,
    },
    4: {
        coins: 0,
        tickets: 0,
    }
}